import React, { useState, useRef } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import success from '../../media/success.m4r';

const BookTable = () => {
    const form = useRef();
    const [isLoading, setIsLoading] = useState(false)


    const sendEmail = (e) => {
        e.preventDefault();
        setIsLoading(true);
        emailjs.sendForm('service_vs0lx4b', 'template_uh8pni4', form.current, 'pU-CHD5He22wbMLLi')
            .then((result) => {
                const audio = new Audio();
                audio.src = success;
                audio.play();
                toast.success("Email Sent Successfully")
                setIsLoading(false);
                e.target.reset();
            }, (error) => {
                console.log(error.text);
            });

    };

    return (
        <div>
            <Header></Header>
            <div style={{ background: 'black' }}>
                <Container className="py-5 col-12 col-lg-9 mx-auto">
                    <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center  text-white">
                        <a target="_blank" href="https://www.quandoo.com.au/place/500-degrees-cronulla-92559/widget?aid=146&utm_source=quandoo-partner&utm_medium=widget-link">
                            <button className="btn btn-lg btn-success w-100">Book Now at Cronulla</button>
                        </a>
                        <a target="_blank" href="https://www.quandoo.com.au/place/500-degrees-33351/widget?aid=146&utm_source=quandoo-partner&utm_medium=widget-link">
                            <button className="btn btn-lg ms-lg-2 mt-2 mt-lg-0 btn-success w-100">Book Now at  Kogarah</button>
                        </a>

                    </div>
                    <hr className="text-white" />
                    <form ref={form} onSubmit={sendEmail} className="col-12 col-md-10 col-xl-6 mx-auto my-5">
                        <h5 className="text-white fw-bold mb-4">We would love to hear from you</h5>
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="floatingName" placeholder="name@example.com"
                                required name="name" />
                            <label htmlFor="floatingName">Your Name</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input name="email" type="email" className="form-control" id="floatingEmail" placeholder="Email" required />
                            <label htmlFor="floatingEmail">Your Email</label>
                        </div>
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="floatingSubject" placeholder="name@example.com"
                                required name="subject" />
                            <label htmlFor="floatingSubject">Subject</label>
                        </div>

                        <div className="form-floating mb-2">
                            <textarea style={{ height: '200px' }} type="text" className="form-control" id="floatingMessage" placeholder="Leave us a message" required name="message" />
                            <label htmlFor="floatingMessage">Leave us a message</label>
                        </div>
                        {
                            !isLoading
                                ?
                                <button type="submit" className="w-100 btn btn-outline-warning btn-lg mt-4 rounded-pill">Submit <FontAwesomeIcon icon={faPaperPlane} /></button>
                                :
                                <button type="submit" className="w-100 btn btn-warning btn-lg mt-4 rounded-pill" disabled><i className="fa fa-spinner fa-spin"></i> Sending</button>
                        }
                    </form>
                </Container>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default BookTable;